<ng-container *ngIf="allCategoryKeys.length >= maxCategoriesForPolarChart; else polarChartCompetencyMatrixTemplate">
    <dx-chart
        class="matrix-chart"
        [dataSource]="competencyMatrixData"
    >
        <dxi-series
            type="line"
            [name]="'DASHBOARD.COMPETENCY-MATRIX-TEAM' | translate"
            argumentField="categoryKey"
            valueField="countOfCompletedEventsForTeam"
        >
        </dxi-series>
        <dxi-series
            type="line"
            [name]="'DASHBOARD.COMPETENCY-MATRIX-USER' | translate"
            argumentField="categoryKey"
            valueField="countOfCompletedEventsForUser"
        >
        </dxi-series>
        <dxo-argument-axis>
            <dxo-label
                [visible]="true"
                [overlappingBehavior]="'rotate'"
                [rotationAngle]="allCategoryKeys.length >= maxCategoriesForInclineLabels ? 90 : 45"
                [customizeText]="customizeCategoryLabel"
                [customizeHint]="customizeCategoryHint"
            >
            </dxo-label>
        </dxo-argument-axis>
        <dxo-tooltip
            [enabled]="true"
            [customizeTooltip]="customizeTooltip"
        ></dxo-tooltip>
        <dxo-legend
            [visible]="true"
            horizontalAlignment="center"
            verticalAlignment="bottom"
        >
            <dxo-margin [top]="40"></dxo-margin>
        </dxo-legend>
    </dx-chart>
</ng-container>

<ng-template #polarChartCompetencyMatrixTemplate>
    <dx-polar-chart
        class="matrix-chart"
        [dataSource]="competencyMatrixData"
        [useSpiderWeb]="true"
    >
        <dxi-series
            type="line"
            [name]="'DASHBOARD.COMPETENCY-MATRIX-TEAM' | translate"
            argumentField="categoryKey"
            valueField="countOfCompletedEventsForTeam"
        >
        </dxi-series>
        <dxi-series
            type="line"
            [name]="'DASHBOARD.COMPETENCY-MATRIX-USER' | translate"
            argumentField="categoryKey"
            valueField="countOfCompletedEventsForUser"
        >
        </dxi-series>
        <dxo-common-series-settings
            type="line"
        ></dxo-common-series-settings>
        <dxo-argument-axis [categories]="allCategoryKeys">
            <dxo-label
                [visible]="true"
                [overlappingBehavior]="'none'"
                [customizeText]="customizeCategoryLabel"
                [customizeHint]="customizeCategoryHint"
            >
            </dxo-label>
        </dxo-argument-axis>
        <dxo-tooltip
            [enabled]="true"
            [customizeTooltip]="customizeTooltip"
        ></dxo-tooltip>
        <dxo-legend
            [visible]="true"
            horizontalAlignment="center"
            verticalAlignment="bottom"
        >
            <dxo-margin [top]="40"></dxo-margin>
        </dxo-legend>
    </dx-polar-chart>
</ng-template>